module.exports = __webpack_public_path__ + "media/img/flags/en-83575385d3dade869a2d8c877624d2d4.svg";